import { SET_GLA_RESULT_AVAILABLE } from 'Action/esriResponseAction';

const initialState = {
  isGLAResultAvailable: false,
};

const glaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GLA_RESULT_AVAILABLE:
      return {
        ...state,
        isGLAResultAvailable: action.payload,
      };
    default:
      return state;
  }
};

export default glaReducer;
